import React, { useState, useRef, useEffect, useMemo } from 'react';
import { useParams, Link  } from 'react-router-dom';
import { variables } from '../Variables/Variable';
import { toast } from 'react-toastify';
import Pagination from './Pagination/Pagination';



const Protfolio = (props) => {
    const ID = useParams();
    const [menu, setMenu] = useState([]);
    const [albums, setAlbums] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [productCount, setProductCount] = useState("");
    let LIMIT = 20;

    const getMenuDetails = () => {
        fetch(variables.API_URL + "Menu/GetMenuDetails/" + 7, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((Response) => {
                if (Response.ok) {
                    return Response.json();
                }
            })
            .then((Result) => {
                setMenu(Result)
            });
    };
    useMemo(() => {
        fetch(variables.API_URL + "Album/GetAlbumsWithItems/", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                pageId: currentPage,
                count: LIMIT,
            })
        })
            .then((Response) => {
                if (Response.ok) {
                    return Response.json();
                }
            })
            .then((Result) => {
                setAlbums(Result.items);
                setProductCount(Result.Count);
            });
    }, [currentPage]);

    useEffect(() => {
        getMenuDetails();
    }, [props])
    return (
        <>
            {/* <!--Start Page Header--> */}
            <section className="page-header">
                <div className="page-header__bg" style={{ backgroundImage: `url(${variables.PHOTO_URL + menu.ImageUrl})` }}>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="page-header__wrapper">
                                <div className="page-header__content">
                                    <h2>{ID.MenuTitle}</h2>
                                    <div className="page-header__menu">
                                        <ul>
                                            <li><a href="/">Home</a></li>
                                            <li>{ID.MenuTitle}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!--End Page Header--> */}

            {/* <!--Start Projects One--> */}
            <section className="projects-one projects-one--protfolio">
                <div className="auto-container">
                    <div className="row">
                        {
                            albums.map((album, index) => {
                                return (
                                    <div key={index} className="col-xl-3 col-lg-6 wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="1500ms">
                                        <div className="projects-one__single">
                                            <div className="projects-one__single-img">
                                                <Link to={`/Portfolio-Details/${album.AlbumId}`}>
                                                    <img src={variables.PHOTO_URL + album.AlbumItems[0]?.ImageUrl} alt="" style={{ width: '400px', height: '300px' }} />
                                                </Link>
                                            </div>
                                            <div className="projects-one__single-content">
                                                <h2><Link to={`/Portfolio-Details/${album.AlbumId}`}>{album.AlbumName}</Link></h2>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                        <Pagination
                            currentPage={currentPage}
                            totalCount={productCount}
                            pageSize={LIMIT}
                            onPageChange={page => setCurrentPage(page)}
                        />
                    </div>
                </div>

            </section>
            {/* <!--End Projects One--> */}
        </>
    )
}

export default Protfolio